var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChildPair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97,
    height: 35,
    viewBox: "0 0 97 35",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "childPair-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 35,
    transform: "translate(-2.657 1.126)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "childPair",
    transform: "translate(2.657 -1.126)",
    clipPath: "url(#childPair-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.46,39.941c-2.282-5.559-8.874-6.028-11.73-7.413A10.907,10.907,0,0,1,56.574,22.48c0-3.953,2.758-7.155,6.156-7.155s6.156,3.205,6.156,7.155A10.907,10.907,0,0,1,62.73,32.528c-2.86,1.385-9.448,1.854-11.73,7.413",
    transform: "translate(-5.157 -4.815)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.46,39.941c-2.282-5.559-8.874-6.028-11.73-7.413A10.907,10.907,0,0,1,56.574,22.48c0-3.953,2.758-7.155,6.156-7.155s6.156,3.205,6.156,7.155A10.907,10.907,0,0,1,62.73,32.528c-2.86,1.385-9.448,1.854-11.73,7.413",
    transform: "translate(-28.617 -4.815)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildPair);
export default __webpack_public_path__ + "static/media/childPair.52314110d5797a0da2b98222457984f1.svg";
export { ForwardRef as ReactComponent };